
const digest = 'dbe69edd5d8510bf79a258cedae9a14b36d3a16c189cd3b55f7c545839ada562';
const classes = {"wrapper":"_wrapper_1qc4j_1","controls":"_controls_1qc4j_5","list":"_list_1qc4j_9"};
const css = `._wrapper_1qc4j_1 {
  font-family: Rubik, "sans-serif";
  margin: -34px -24px;
}
._wrapper_1qc4j_1 ._controls_1qc4j_5 {
  padding: 12px 24px;
  border: 1px solid #eaedf3;
}
._wrapper_1qc4j_1 ._list_1qc4j_9 {
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  padding: 24px;
  gap: 25px;
  display: flex;
  flex-direction: column;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  